export const PRODUCT_LISTING = 'PRODUCT_LISTING'
export const PRODUCT_LISTING_SUCCESS = 'PRODUCT_LISTING_SUCCESS'